import script from "./ManageDependents.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageDependents.vue?vue&type=script&setup=true&lang=js"

import "./ManageDependents.vue?vue&type=style&index=0&id=2c7b61b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7b61b6"]])

export default __exports__